import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

import { environment } from "../../../../environments/environment";
import { formatDate } from "@angular/common";

@Injectable({
  providedIn: "root",
})
export class BexioService {
  url = environment.apiUrl + "/apps-connector";

  constructor(private http: HttpClient) {}

  getBexioLoginUrl(): Observable<string> {
    return this.http.get<string>(this.url + "/bexio/login");
  }
  getBexioTokenStatus(): Observable<any> {
    return this.http.get<any>(this.url + "/bexio/token-status");
  }

  syncInvoice(invoiceId: string) {
    return this.http.post<{ status: string }>(this.url + "/bexio/sync-invoice/" + invoiceId, {});
  }
  importBexioContacts() {
    return this.http.post(this.url + "/bexio/import-contacts", {});
  }

  exportInvoicesToBexio(from: Date, to: Date) {
    return this.http.post(
      this.url + "/export-invoices",
      {},
      {
        params: {
          from: formatDate(from, "yyyy-MM-dd", "fr-FR"),
          to: formatDate(to, "yyyy-MM-dd", "fr-FR"),
        },
      },
    );
  }

  logout() {
    return this.http.delete(this.url + "/bexio/logout");
  }
}
